const styles = ({ forms, typography }) => ({
  ...typography.p3,
  display: 'block',
  fontSize: forms.label.fontSizeFocused,
  textTransform: 'uppercase',
  width: '100%',
});

export default styles;
